import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=065f0587&scoped=true&"
import script from "./FormInput.vue?vue&type=script&lang=js&"
export * from "./FormInput.vue?vue&type=script&lang=js&"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=065f0587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f0587",
  null
  
)

export default component.exports